const secondary = {
    social_bind_with: 'Đã có tài khoản? Đăng nhập để liên kết {{methods, list(type: disjunction;)}} với danh tính mạng xã hội của bạn.',
};
export default Object.freeze(secondary);
